/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from 'reactstrap';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports

// local imports
import './ClientSubscriptions.css';
import UserNotApproved from './UserNotApproved';
import ProviderNavbar from './ProviderNavbar';
import Loading from '../../../assets/UW_Horizontal_Logo_Full.png';
import ClientSubscriptionsTable from './ClientSubscriptionsTable';

const ClientSubscriptions = props => {

    // contexts
    const { theme } = useContext(ThemeContext);
    const { userApprovalStatus } = useContext(AuthContext);

    // states
    const [activeTab, setActiveTab] = useState("history");
    const [isLoading, setIsLoading] = useState(false);

    // useEffects

    // function's return
    return (
        <div className='clientSubscription'>
            <ProviderNavbar history={props.history} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    userApprovalStatus || true ?
                        <div className='p-3'>
                            {/* Page Heading */}
                            <div>
                                <h1 style={theme.headingBold}>Client Subscriptions</h1>
                                <hr style={{ borderWidth: "2px" }} />
                            </div>
                            <div className='d-flex'>
                                <Nav tabs className='mx-auto'>
                                    <NavItem className={activeTab === "active" ? 'active' : ''} >
                                        <NavLink
                                            onClick={() => setActiveTab("active")}
                                        >
                                            Active
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={activeTab === "history" ? 'active' : ''} >
                                        <NavLink
                                            onClick={() => setActiveTab("history")}
                                        >
                                            History
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                            <TabContent activeTab={activeTab} className='p-2'>
                                <TabPane tabId="active">
                                    <ClientSubscriptionsTable tabName="active" />
                                </TabPane>
                                <TabPane tabId="history">
                                    <ClientSubscriptionsTable tabName="history" />
                                </TabPane>
                            </TabContent>
                        </div>
                        :
                        <UserNotApproved />
            }
        </div >
    )

}

export default ClientSubscriptions;